import React from 'react';
import { useIntl } from 'react-intl';

import ActionButton from 'components/widgets/ActionButton/ActionButton';
import ExpandedErrorLogModal from 'components/widgets/Modal/ExpandedErrorLogModal/ExpandedErrorLogModal';
import { checkExtendedErrorLogActivity } from 'context/error/helpers/checkExtendedErrorLogActivity';
import { ErrorContextPropsValue } from 'context/error/types';
import { useModalContext } from 'context/modal/modal';

function ExtendedErrorModalButton({ error }: { error: ErrorContextPropsValue }) {
  const modalContext = useModalContext();
  const isExtendedErrorLogActive = checkExtendedErrorLogActivity();
  const intl = useIntl();
  const buttonLabel = intl.formatMessage({ defaultMessage: 'Expand log', id: 'expandLogId' });

  const handleOpenModal = () => {
    modalContext.openModal(<ExpandedErrorLogModal errorData={error} />);
  };

  if (!isExtendedErrorLogActive) {
    return null;
  }

  return (
    <ActionButton title={buttonLabel} onClick={handleOpenModal} />
  );
}

export default ExtendedErrorModalButton;
